"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _svgIcon = require("../SvgIcon");
var _default = (0, _svgIcon).makeIcon("Icon24Dropdown", "dropdown_24", "0 0 24 24", '<symbol viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" id="dropdown_24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z" /><path d="M12 14.198 6.64 9.732a1 1 0 1 0-1.28 1.536l6 5a1 1 0 0 0 1.28 0l6-5a1 1 0 1 0-1.28-1.536L12 14.198Z" fill="currentColor" fill-rule="nonzero" /></g></symbol>', 24, 24, false, undefined);
exports.default = _default;
